import { useState } from "react";
import { Check, Heart } from "lucide-react";

export function MasonryCard({ item, selected, onToggle, mode = "check", tag }) {
  const [broken, setBroken] = useState(false);
  if (broken) return null;
  return (
    <div
      data-testid={`image-card-${item.id}`}
      onClick={() => onToggle(item)}
      className="group relative rounded-2xl overflow-hidden cursor-pointer bg-neutral-100 transition-transform duration-300 hover:scale-[1.015]"
    >
      <img src={item.url} alt={item.title} loading="lazy" onError={() => setBroken(true)} className="w-full block" />
      <div className={`absolute inset-0 transition-opacity duration-300 ${selected ? "bg-black/35 opacity-100" : "bg-black/25 opacity-0 group-hover:opacity-100"}`} />
      <div className="absolute bottom-3 left-3 right-14 text-white text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300 drop-shadow">
        {item.title}
      </div>
      {tag && (
        <span data-testid={`image-tag-${item.id}`} className="absolute bottom-3 left-3 rounded-full bg-white/90 text-neutral-900 text-[11px] font-semibold px-2.5 py-1">
          {tag}
        </span>
      )}
      <span
        className={`absolute top-3 right-3 h-9 w-9 rounded-full flex items-center justify-center transition-[background-color,transform,opacity] duration-300 ${selected ? "bg-neutral-900 text-white scale-100 opacity-100" : "bg-white/90 text-neutral-900 scale-90 opacity-0 group-hover:opacity-100 group-hover:scale-100"}`}
      >
        {mode === "heart" ? <Heart size={16} fill={selected ? "currentColor" : "none"} /> : <Check size={16} />}
      </span>
    </div>
  );
}

export function Masonry({ children }) {
  return <div className="masonry columns-2 sm:columns-3 lg:columns-4 xl:columns-5">{children}</div>;
}
